var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52892 13.1384C7.78927 13.3987 8.21138 13.3987 8.47173 13.1384C8.73208 12.878 8.73208 12.4559 8.47173 12.1956L4.94313 8.66699H12.667C13.0352 8.66699 13.3337 8.36852 13.3337 8.00033C13.3337 7.63213 13.0352 7.33366 12.667 7.33366H4.94313L8.47173 3.80506C8.73208 3.54471 8.73208 3.1226 8.47173 2.86225C8.21138 2.6019 7.78927 2.6019 7.52892 2.86225L2.86273 7.52845C2.86112 7.53005 2.85952 7.53167 2.85792 7.53329C2.74026 7.65313 2.66753 7.81724 2.66699 7.99833L2.66699 8.00033L2.66699 8.00232C2.66726 8.09199 2.68522 8.17749 2.71758 8.25551C2.74937 8.33236 2.79615 8.40446 2.85792 8.46736C2.85949 8.46896 2.86108 8.47055 2.86266 8.47214M2.86266 8.47214L7.52892 13.1384L2.86266 8.47214Z",
    fill: "#1E2132"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.cbd50166.svg";
export { ForwardRef as ReactComponent };